<template>
  <div class="modeList_wrapper">
    <div class="modeList_content">
      <div class="modeList_search">
        <el-input
          placeholder="查找机组型号"
          class="input-with-select"
          size="small"
          v-model="keyword"
          @keyup.enter.native="search()"
        >
          <i
            class="el-input__icon el-icon-search"
            slot="suffix"
            @click="search"
          >
          </i>
        </el-input>
      </div>
      <!--<div class="modeList_btn">
         <el-button
          type="text"
          class="compare-button"
          @click="cancelCompare()"
          :disabled="!isCompareClick"
          :class="{
            compare_btn: isCompareClick
          }"
        >
          退出对比
        </el-button>
        <el-button
          @click="compareClick"
          :loading="compareButtonLoading"
          :disabled="checkedListItem.length < 2"
          :class="{ compare_btn: checkedListItem.length > 1 }"
          >对比</el-button
        >
      </div>-->

      <div class="modeList_list">
        <el-table
          v-show="type == '0'"
          v-loading="tableLoading"
          element-loading-text="加载中"
          element-loading-spinner="el-icon-loading"
          :show-header="false"
          ref="leftmultipleTable"
          :data="leftTurbineList"
          highlight-current-row
          current-row-key="1"
          row-class-name="model-list-table-row-class"
          @row-click="handleModelClick"
          @select="handleSelectionChange"
          key="44"
        >
          <el-table-column
            prop="turbineType"
            min-width="130"
            header-align="left"
          ></el-table-column>
          <el-table-column
            prop="turbineType"
            min-width="40"
            header-align="left"
          >
            <template slot-scope="scope">
              <span @click="delOption(scope.row)" v-if="scope.row.isOpFlag">
                <i
                  class="el-icon-delete"
                  style="color: #98989c;padding-left: 10px;"
                ></i>
              </span>
            </template>
          </el-table-column>
        </el-table>

        <!-- 个人列表  目前没有个人，只有公共列表-->
        <!--        <el-table
          v-show="type == '1'"
          v-loading="tableLoading"
          element-loading-text="加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          ref="rightmultipleTable"
          :data="rightTurbineList"
          border
          highlight-current-row
          current-row-key="1"
          row-class-name="model-list-table-row-class cursor-pointer"
          header-row-class-name="model-list-table-header-class"
          style="width: 100%;background-color: #32323a"
          @row-click="handleModelClick"
          @select="handleSelectionChange"
          key="45"
        >
          >
          <el-table-column
            type="selection"
            width="40"
            header-align="right"
          ></el-table-column>
          <el-table-column
            prop="turbineType"
            min-width="130"
            label="机型名字"
            header-align="left"
          ></el-table-column>
          <el-table-column
            prop="turbineType"
            min-width="130"
            header-align="left"
          >
            <template slot-scope="scope">
              <span @click="delOption(scope.row)" v-if="scope.row.isOpFlag">
                <i
                  class="el-icon-delete"
                  style="color: #98989c;padding-left: 10px;"
                ></i>
              </span>
            </template>
          </el-table-column>
        </el-table>-->
      </div>
    </div>
    <!--底部删除 对比功能删除-->
    <!--    <div class="modeList_delbox">
      <el-checkbox
        :indeterminate="isIndeterminate"
        v-model="checkAll"
        @change="handleBottomCheckAllChange"
        align="center"
        class="bottom-checked-all"
        >全选</el-checkbox
      >
      &lt;!&ndash;<span
        class="text-btn"
        v-if="checkedListItem.length > 0"
        @click="delOption"
        >删除所选</span
      >&ndash;&gt;
      <span
        class="cancel-check"
        v-if="checkAll"
        @click="cancelBottomCheckAllChange"
        >取消全选</span
      >
      <div class="modeList_btn">
        &lt;!&ndash;<el-button
          v-if="isCompareClick"
          @click="cancelCompare"
          :class="{
            compare_btn: isCompareClick
          }"
        >
          退出对比
        </el-button>&ndash;&gt;
        <el-button
          @click="compareClick"
          :loading="compareButtonLoading"
          :disabled="checkedListItem.length < 2"
          :class="{ compare_btn: checkedListItem.length > 1 }"
          v-if="checkedListItem.length > 1 && !compareButtonClick"
          >对比</el-button
        >
        <el-button
          type="text"
          class="compare-button"
          @click="cancelCompare()"
          :disabled="!isCompareClick"
          v-if="compareButtonClick && checkedListItem.length > 1"
          :class="{
            compare_btn: isCompareClick
          }"
        >
          退出对比
        </el-button>
      </div>
    </div>-->
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
      type: '0',
      keyword: '',
      list: [],
      tableLoading: false,
      currentListItem: '', // 当前点击的机型
      checkedListItem: [], // 当前选中的list机型
      // 底部选择和删除
      isIndeterminate: false,
      checkAll: false,
      // 机型库列表
      leftTurbineList: [],
      rightTurbineList: [],
      buttonLoading: false, // 对比按钮的loading加载状态
      leftCheckedList: [], // 左边选中的
      rightCheckedList: [], // 右边选中的
      allList: [], // 所有的选中的
      checkedList: [],
      isCompareClick: false,
      compareButtonClick: false // 是否点击了对比按钮
    };
  },
  computed: {
    ...mapState('model', ['isCompare', 'uploadSuccess', 'compareButtonLoading'])
  },
  mounted() {
    this.$store.commit('model/TUR_TYPE', this.type);
    this.fetchTurbineList();
  },
  watch: {
    type(val) {
      this.$store.commit('model/TUR_TYPE', val);
      // this.fetchTurbineList();
      // 切换全部和我的，取消选中和全选
      // this.cancelBottomCheckAllChange();
      this.$nextTick(() => {
        if (this.leftCheckedList.length > 0) {
          for (let index = 0; index < this.leftCheckedList.length; index++) {
            if (this.$refs.leftmultipleTable) {
              this.$refs.leftmultipleTable.toggleRowSelection(
                this.leftTurbineList.find(item => {
                  return (
                    this.leftCheckedList[index].turbineTypeId ===
                    item.turbineTypeId
                  );
                }),
                true
              );
            }
          }
        } else {
          this.$refs.leftmultipleTable.clearSelection();
        }
        if (this.rightCheckedList.length > 0) {
          for (let index = 0; index < this.rightCheckedList.length; index++) {
            if (this.$refs.rightmultipleTable) {
              this.$refs.rightmultipleTable.toggleRowSelection(
                this.rightTurbineList.find(item => {
                  return (
                    this.rightCheckedList[index].turbineTypeId ===
                    item.turbineTypeId
                  );
                }),
                true
              );
            }
          }
        } else {
          this.$refs.rightmultipleTable.clearSelection();
        }
      });
      this.list = val == '0' ? this.leftTurbineList : this.rightTurbineList;
      if (val == '0') {
        this.isIndeterminate = this.leftCheckedList.length > 0 ? true : false;
        if (this.leftCheckedList.length === this.leftTurbineList.length) {
          this.checkAll = true;
          this.isIndeterminate = false;
        } else {
          this.checkAll = false;
        }
      } else {
        this.isIndeterminate = this.rightCheckedList.length > 0 ? true : false;
        if (this.rightCheckedList.length === this.rightTurbineList.length) {
          this.checkAll = true;
          this.isIndeterminate = false;
        } else {
          this.checkAll = false;
        }
      }
    },
    // 退出对比做一下列表选择重置
    isCompare(val) {
      if (!val) {
        this.checkAll = false;
        this.isIndeterminate = false;
        if (this.type == '0') {
          this.$store.commit('model/CURRENT_TURBINE', this.leftTurbineList[0]);
        } else {
          this.$store.commit('model/CURRENT_TURBINE', this.rightTurbineList[0]);
        }
        this.checked();
      }
    },
    checkedList(val) {
      // //console.log('==========');
      // //console.log(val);
      // let newVal = val.map(eco => {
      //   return eco.turbineTypeId;
      // });
      // // 找出相同重复元素
      // let tmp = [];
      // if (Array.isArray(newVal)) {
      //   newVal
      //     .concat()
      //     .sort()
      //     .sort(function(a, b) {
      //       if (a == b && tmp.indexOf(a) === -1) tmp.push(a);
      //     });
      // }
      // for (let i = 0; i < tmp.length; i++) {
      //   // let temp = 0;
      //   // newVal.forEach((item, df) => {
      //   //   if (item == tmp[i]) {
      //   //     temp++;
      //   //     if (temp == 2) {
      //   //       let index = df;
      //   //       val[index].turbineTypeId = val[index].turbineTypeId + 's';
      //   //     }
      //   //   }
      //   // });
      //   if (newVal.indexOf(tmp[i]) !== -1) {
      //     let index = newVal.indexOf(tmp[i]);
      //     val[index].turbineTypeId = val[index].turbineTypeId + 's';
      //     continue;
      //   }
      // }
      // let newlist = [];
      // for (let i = 0; i < val.length; i++) {
      //   if (typeof val[i].turbineTypeId != 'string') {
      //     newlist.push(val[i]);
      //   }
      // }
      // val.forEach(item => {
      //   if (typeof item.turbineTypeId == 'string') {
      //     newlist.push(item);
      //   }
      // });
      // //console.log(newlist);
      // newlist = [...newlist];
      if (val.length <= 1) {
        this.compareButtonClick = false;
      }
      this.$store.commit('model/TURBINE_CHECKED_LIST', val);
    },
    list(val) {
      if (val.length === 0) {
        this.$store.commit('model/CURRENT_TURBINE', []);
        return;
      }
      if (!this.isCompare && val.length > 0) {
        this.$store.commit('model/CURRENT_TURBINE', val[0]);
        this.checked();
      }
    },
    // 数据上传成功刷新机型库列表
    uploadSuccess(val) {
      if (val) {
        this.fetchTurbineList();
      }
    }
  },
  methods: {
    checked() {
      this.$nextTick(function() {
        if (this.$refs.leftmultipleTable) {
          this.$refs.leftmultipleTable.setCurrentRow(this.leftTurbineList[0]);
        }
        if (this.$refs.rightmultipleTable) {
          this.$refs.rightmultipleTable.setCurrentRow(this.rightTurbineList[0]);
        }
      });
    },
    async fetchTurbineList() {
      this.list = [];
      this.leftTurbineList = [];
      this.rightTurbineList = [];
      if (this.tableLoading) {
        return;
      }
      this.tableLoading = true;
      let apiKey = 'test';
      let result1 = await this.$fetch('/windfarm/turbineType/getTurbineMenu', {
        params: {
          keyword: this.keyword,
          apiKey
        },
        showError: true
      })
        .then(res => {
          this.tableLoading = false;
          return res;
        })
        .catch(() => {
          this.tableLoading = false;
        });
      // let result2 = await this.$fetch('/windfarm/turbineType/getTurbineMenu', {
      //   params: {
      //     keyword: this.keyword,
      //     type: '1',
      //     apiKey
      //   },
      //   showError: true
      // })
      //   .then(res => {
      //     this.tableLoading = false;
      //     return res;
      //   })
      //   .catch(() => {
      //     this.tableLoading = false;
      //   });
      this.leftTurbineList = result1.data.menu;
      this.rightTurbineList = result1.data.menu;
      if (this.leftTurbineList.length > 0 || this.rightTurbineList.length > 0) {
        this.allList = this.leftTurbineList.concat(this.rightTurbineList);
        this.list =
          this.type == '0' ? this.leftTurbineList : this.rightTurbineList;
        this.isIndeterminate = this.checkedList.length > 0 ? true : false;
        this.checkAll = false;
        this.tableLoading = false;
        this.$store.commit('model/UPLOAD_SUCCESS', false);
      } else {
        this.$refs.rightmultipleTable.setCurrentRow();
        this.$refs.leftmultipleTable.setCurrentRow();
        this.$store.commit('model/CURRENT_TURBINE', []);
        this.tableLoading = false;
      }
    },
    search() {
      this.fetchTurbineList();
    },
    // 机型库列表点击
    handleModelClick(val) {
      this.currentListItem = val;
      this.$store.commit('model/CURRENT_TURBINE', val);
    },
    // 机型库列表选择
    handleSelectionChange(val, row) {
      //console.log('JJJJJJJJJJJJJJ');
      console.log;
      //console.log(val);
      //console.log(this.rightCheckedList);
      //console.log(this.checkedList);
      if (typeof row !== 'undefined') {
        let ids = this.checkedList.map(item => {
          return item.turbineTypeId;
        });
        if (this.isCompare) {
          if (ids.includes(row.turbineTypeId)) {
            if (this.type == '0' && val.length > this.leftCheckedList.length) {
              val[val.length - 1].turbineTypeId =
                val[val.length - 1].turbineTypeId + 's';
            }
            if (this.type == '1' && val.length > this.rightCheckedList.length) {
              val[val.length - 1].turbineTypeId =
                val[val.length - 1].turbineTypeId + 's';
            }
          }
        } else {
          if (ids.includes(row.turbineTypeId)) {
            if (this.type == '0' && val.length > this.leftCheckedList.length) {
              val[val.length - 1].turbineTypeId =
                val[val.length - 1].turbineTypeId + 's';
            }
            if (this.type == '1' && val.length > this.rightCheckedList.length) {
              val[val.length - 1].turbineTypeId =
                val[val.length - 1].turbineTypeId + 's';
            }
          }
        }
      } else {
        // if (this.leftTurbineList.length == val.length && this.isCompare) {
        //
        // }
      }
      //console.log(val);
      if (this.type == '0') {
        if (val.length > 0) {
          this.leftCheckedList = val.map(item => {
            return item;
          });
        } else {
          this.leftCheckedList = [];
        }
      } else {
        if (val.length > 0) {
          this.rightCheckedList = val.map(item => {
            return item;
          });
        } else {
          this.rightCheckedList = [];
        }
      }
      let checkedList = [...this.leftCheckedList, ...this.rightCheckedList];
      this.checkedList = checkedList.map(item => {
        return item;
      });
      this.checkedListItem = checkedList;
      if (checkedList.length < 2) {
        this.$store.commit('model/COMPARE_BUTTON', false);
      }
      if (this.type == '0') {
        if (val.length < this.leftTurbineList.length && val.length > 0) {
          this.isIndeterminate = true;
          this.checkAll = false;
        } else if (val.length === this.leftTurbineList.length) {
          this.isIndeterminate = false;
          this.checkAll = true;
        } else if (val.length == 0) {
          this.isIndeterminate = false;
          this.checkAll = false;
        }
      } else {
        if (val.length < this.rightTurbineList.length && val.length > 0) {
          this.isIndeterminate = true;
          this.checkAll = false;
        } else if (val.length === this.rightTurbineList.length) {
          this.isIndeterminate = false;
          this.checkAll = true;
        } else if (val.length == 0) {
          this.isIndeterminate = false;
          this.checkAll = false;
        }
      }
    },
    // 点击对比
    compareClick() {
      if (this.checkedListItem.length < 2) {
        return;
      }
      this.$store.commit('model/COMPARE_BUTTON', true);
      this.isCompareClick = true;
      this.compareButtonClick = !this.compareButtonClick;
    },
    // 退出对比
    cancelCompare() {
      this.isCompareClick = false;
      this.compareButtonClick = false;
      this.cancelBottomCheckAllChange();
    },
    delOption(item) {
      if (this.isCompare) {
        this.$message({
          type: 'warning',
          message: '对比状态下不能进行删除！'
        });
        return;
      }
      this.$confirm('确定要删除该机型数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let id = item.turbineTypeId;
          this.$fetch('/windfarm/turbineType/delTurbineMenu', {
            showError: true,
            showSuccess: true,
            params: {
              turbineTypeId: id
            }
          }).then(() => {
            // 重新获取机组数据列表
            this.fetchTurbineList();
          });
        })
        .catch(() => {});
    },
    // 全选机型列表
    handleBottomCheckAllChange() {
      if (this.type == '0') {
        if (
          this.$refs.leftmultipleTable.selection.length <
          this.leftTurbineList.length
        ) {
          this.handleSelectionChange(this.leftTurbineList);
          this.$refs.leftmultipleTable.toggleAllSelection();
          this.checkAll = true;
        } else {
          this.leftCheckedList = [];
          this.rightCheckedList = [];
          this.checkedList = [];
          this.checkedListItem = [];
          this.checkAll = false;
          this.$refs.leftmultipleTable.clearSelection();
          this.handleSelectionChange([]);
          this.$store.commit('model/COMPARE_BUTTON', false);
        }
      } else {
        if (
          this.$refs.rightmultipleTable.selection.length <
          this.rightTurbineList.length
        ) {
          this.checkAll = true;
          this.handleSelectionChange(this.rightTurbineList);
          this.$refs.rightmultipleTable.toggleAllSelection();
        } else {
          this.leftCheckedList = [];
          this.rightCheckedList = [];
          this.checkedList = [];
          this.checkedListItem = [];
          this.checkAll = false;
          this.$refs.rightmultipleTable.clearSelection();
          this.handleSelectionChange([]);
          this.$store.commit('model/COMPARE_BUTTON', false);
        }
      }
    },
    // 取消全选机型列表
    cancelBottomCheckAllChange() {
      this.isIndeterminate = false;
      this.checkAll = false;
      this.leftCheckedList = [];
      this.rightCheckedList = [];
      this.checkedList = [];
      this.checkedListItem = [];
      this.isCompareClick = false;
      if (this.type == '0') {
        this.$refs.leftmultipleTable.clearSelection();
      } else {
        this.$refs.rightmultipleTable.clearSelection();
      }
      // this.isIndeterminate = false;
      // this.checkAll = false;
      // this.checkedListItem = [];
      // this.$refs.leftmultipleTable.clearSelection();
      this.handleSelectionChange([]);
      this.$store.commit('model/COMPARE_BUTTON', false);
    }
  }
};
</script>

<style lang="less" scoped>
.modeList {
  &_top {
    background-color: #081a29;
    //padding-bottom: 15px;
  }
  &_content {
    /* background-color: rgb(225, 46, 46); */
    padding-bottom: 25px;
    .Order-Code{
      width: 87%;
      height: 30px;
      border-bottom:1px solid #fff;
      font-size:16px;
     margin: 15px auto 10px;

    }
  }
  &_title {
    font-size: 24px;
    font-weight: bold;
    color: #fff;
    padding: 30px 0;
    text-align: center;
  }
  &_radio {
    text-align: center;
    padding: 20px 0;
  }
  &_search {
    width: 194px;
    margin: 0 auto 12px;
    padding-top: 13px;
    input {
      background: #f6f8ff;
      outline: none;
      height: 27px !important;
      line-height: 27px !important;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.3);
      font-style: normal;
      /* identical to box height, or 114% */
      /* Gray 3 */
      color: #828282;
      /* Gray 5 */
      //border: 1px solid #e0e0e0;
      box-sizing: border-box;
      border-radius: 4px;
      padding-left: 8px;
    }
    .el-icon-search {
      line-height: 37px !important;
    }
  }
  /*&_btn {
    text-align: right;
    padding-right: 18px;
    .el-button {
      padding: 0;
      width: 66px;
      height: 26px;
      line-height: 26px;
      text-align: center;
      background: rgba(70, 72, 80, 0);
      border: 1px solid rgba(152, 152, 155, 0.3);
      border-radius: 6px;
      display: inline-block;
      font-size: 14px;
      //font-weight: bold;
      color: #98989b;
    }
    .el-button.is-disabled:hover {
      background-color: #32323a;
      border-color: rgba(152, 152, 155, 0.3);
      color: #98989b;
    }
    .compare_btn {
      background: #0671bb;
      color: #fff;
      cursor: pointer;
    }
  }*/
  &_list {
    /deep/ .el-table {
      font-size: 14px;
      border: none;
      &::before,
      &::after {
        background-color: transparent;
      }
      .el-table__body tr.current-row > td {
        background-color: #1890ff;
        color: #fff;
      
      }
      background-color: transparent;
      th,
      tr {
        background-color: transparent;
        padding: 0;
      }
      .cell {
        text-align: left;
      }

      // 表头
      /* .model-list-table-header-class {
        height: 32px;
        background-color: #0076a2;
        color: #fff;
        display: none;
        th {
          font-weight: normal !important;
          border: none;
          border: 0;
        }
      } */

      // 表行
      .model-list-table-row-class {
        height: 30px;
        &:hover {
          /* color: #eee; */
          td {
            /* background-color: #233342 !important; */
          }
        }
        td {
          padding: 10px 0;
          /* background-color: transparent; */
          border-bottom: solid 1px #eee;
        }
      }

      .el-table--border,
      .el-table--group {
        border: none;
      }
    }
    /* el-checked-group 做机型库列表 */
    margin-top: 15px;
    .el-checkbox {
      display: block;
      height: 34px;
      line-height: 34px;
      text-align: center;
    }
    .el-checkbox__inner {
      width: 16px !important;
      height: 16px !important;
      border-radius: 50%;
    }
    .el-checkbox__inner::after {
      height: 8px;
      left: 6px;
      width: 3px;
      top: 2px;
    }
    .is-checked {
      .el-checkbox__inner {
        background: #fff;
      }
    }
    .is-checked {
      /* background: #015aac; */
      text-align: center;
      .el-checkbox__inner::after {
        //border: 1px solid rgba(70, 72, 80, 0.5);
        border: 1px solid #0877bf;
        border-left: 0;
        border-top: 0;
      }
      .el-checkbox__label {
        color: #fff;
      }
    }
    /* el-checked-group 做机型库列表 */
    .el-checkbox {
      margin-right: 0;
      text-align: left;
      display: flex;
      align-items: center;
      padding-left: 20%;
    }
    .el-checkbox:not(:first-child) {
      margin-top: 2px;
    }
  }
  &_delbox {
    position: relative;
    width: 230px;
    z-index: 10;
    position: fixed;
    bottom: 0;
    background-color: #28282e;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: white;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    padding-left: 15px;
    /deep/.el-checkbox {
      vertical-align: middle;
      color: #fff;
      font-size: 14px;
      .el-checkbox__input {
        padding-bottom: 2px;
      }
      .el-checkbox__inner {
        width: 18px !important;
        height: 18px !important;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
      }
      .el-checkbox__input.is-checked {
        color: #ffffff;
        font-size: 14px;
      }
      .el-checkbox__label {
        color: #ffffff;
        font-size: 14px;
      }
      .el-checkbox__inner::before {
        top: auto;
      }
      .el-checkbox__inner::after {
        height: 9px;
        left: 6px;
        width: 3px;
        top: 2px;
      }
    }
    .bottom-checked-all {
      padding-right: 10px;
    }
    .cancel-check {
      font-size: 14px;
      cursor: pointer;
    }
    .text-btn {
      color: #fff;
      cursor: pointer;
      padding-right: 10px;
      padding-left: 10px;
      font-size: 14px;
    }

    .modeList_btn {
      position: absolute;
      right: 4px;
      //text-align: right;
      //padding-right: 18px;
      .el-button {
        padding: 0;
        width: 56px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        background: rgba(70, 72, 80, 0);
        border: 1px solid rgba(152, 152, 155, 0.3);
        border-radius: 6px;
        display: inline-block;
        font-size: 14px;
        //font-weight: bold;
        color: #98989b;
      }
      .compare-button {
        width: 80px;
      }
      .el-button.is-disabled:hover {
        background-color: #32323a;
        border-color: rgba(152, 152, 155, 0.3);
        color: #98989b;
      }
      .compare_btn {
        /* background: #0671bb; */
        color: #fff;
        cursor: pointer;
      }
    }
  }
}
</style>
<style lang="less" scoped>
/deep/.el-table__empty-text {
  display: flex;
  padding-left: 30px;
}
/deep/.input-with-select {
  input {
    width: 205px;
    border-radius: 4px;
  }
}
.modeList_search {
  width: 205px;
}
/deep/.el-table__body tr.current-row>td:first-child{
  font-weight: bold;
  /* border-left:3px solid #547EFC!important; */
}
/deep/.el-table td.el-table__cell {
  border: 0;
}
/deep/.el-table th.el-table__cell.is-leaf {
  border: 0;
}
/deep/.el-table::before {
  /* background-color: #fff; */
}
/*/deep/.modeList_list {*/
/*  .cell {*/
/*    font-size: 14px;*/
/*  }*/
/*}*/
</style>
